import React from 'react'
import styled from 'styled-components'

const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  width: 100%;
`

const TitleLine = styled.div`
  flex-grow: 1;
  height: 1px;
  background-color: #d1d5db;
  max-width: 100px;

  @media (min-width: 640px) {
    max-width: 200px;
  }
`

const TitleText = styled.h2`
  margin: 0 16px;
  font-size: 18px;
  font-weight: 400;
  color: hsl(0, 0%, 29%);

  @media (min-width: 640px) {
    font-size: 20px;
  }
`


interface SectionTitleProps {
  title?: string;
}

export const SectionTitle: React.FC<SectionTitleProps> = ({ title }) => {
  return (
    <TitleContainer>
      <TitleLine />
      <TitleText>{title}</TitleText>
      <TitleLine />
    </TitleContainer>
  );
};